import api from './api';

const EnrollmentService = {
  getAll: async (params = {}) => {
    try {
      const response = await api.get('/enrollments/', { params });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  getById: async (id) => {
    try {
      const response = await api.get(`/enrollments/${id}/`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  create: async (data) => {
    try {
      const response = await api.post('/enrollments/', data);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  update: async (id, data) => {
    try {
      const response = await api.patch(`/enrollments/${id}/`, data);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  delete: async (id) => {
    try {
      const response = await api.delete(`/enrollments/${id}/`);
      return response.data;
    } catch (error) {
      throw error;
    }
  }
};

export default EnrollmentService;
